module.exports = [
  {
    name: {
      zh: '甘馬克',
      en: 'MARK GIBSON',
    },
    title: {
      zh: '廚藝管理課程主任<br/>英國',
      en: 'Coordinator for Culinary Arts Management, <br/>United Kingdom',
    },
    description: {
      zh: '甘馬克博士在開始學術生涯前，曾於飲食業工作20多年，先後出任廚師、顧問及前廳經理。甘馬克博士擁有英國曼徹斯特都會大學碩士及博士學位（研究領域：食品管理、環境可持續性和食品安全），目前在旅遊學院任職特邀副教授。作為課程主任，甘馬克博士目前在廚藝管理學位課程中教授食物烹調科目。同時，甘馬克博士和他的團隊正在改進並持續發展相對新的四年制的廚藝管理學位課程。他的職責亦包括如廚房設計和裝修。甘馬克博士亦在技術暨學術委員會、教學委員會和協調員小組的幾個學術實體擔任職務。他目前在籌備將於2019年推出的兩個碩士學位課程。<br/><br/>其著名的出版刊物包括關於食品和相關議題的書籍、論文和文章。此外，甘馬克博士也是多份食物相關期刊的副主編和審稿人。他還協助牛津大學社會科學系的研究及政策部門——環境變化研究所“Foodsource”。同時，甘馬克繼續致力撰寫有關食物書籍和食物相關文章。',
      en: 'Before he began his academic career, Invited Assistant Professor Dr. Mark Gibson worked in the food and beverage industry for more than 20 years in various roles including: as a chef, a consultant and as a front of house manager. Dr. Gibson undertook his Ph.D. in Food Management, Environmental Sustainability and Food Security at Manchester Metropolitan University (United Kingdom). He is currently employed an Invited Assistant Professor at IFT. In his role as programme Coordinator Dr. Gibson is presently lecturing students in areas of food production and preparation in the Institute’s popular Culinary Arts Management degree programme. Simultaneously, Dr. Gibson and his team are revamping and continuing to develop the relatively new 4-year culinary degree course. His work also expands into the operations side with multiple kitchen designs and renovations. Mark also sits on several academic bodies from the CTC through to the Pedagogic council as well as the coordinator’s panel. He is also currently developing 2 Master’s Degree courses at IFT which will be rolled out in 2019.<br/><br/>Some notable publications include several books, papers and articles about food and surrounding issues. As well as writing books and articles, Dr. Gibson is also an associate editor and reviewer for several food-related journals. He also helped with ‘Foodsource’, a research and policy unit based in the Social Sciences Division of the University of Oxford, Environmental Change Institute. Amid all this Mark continues to write books on the broad subjects of food and food related material.',
    },
    image: '/images/tourism/team-01.jpg',
    textLength: 700,
  },
  {
    name: {
      zh: '沈毅孟',
      en: 'SHARIF SHAMS IMON',
    },
    title: {
      zh: '旅遊企業管理及文化遺產管理課程主任<br/>孟加拉',
      en: 'Coordinator for Heritage Management, <br/>Tourism Business Management, Bangladesh',
    },
    description: {
      zh: '作為文化遺產及旅遊管理的國際專家，特邀副教授沈毅孟博士擁有超過20年的教學經驗。他於香港大學取得城市保育的博士學位，研究興趣於城市遺產旅遊，遺產解說和城市保護，是六個專業團體的成員。在專業方面，他曾在14個不同的國家擔任過聯合國教科文組織、聯合國亞洲及太平洋經濟社會委員會和政府專案的顧問。自2005年以來，為聯合國教科文組織世界遺產提名地的專業技術評委和國際古蹟遺址理事會的專業成員。',
      en: 'An international expert in heritage and tourism management, Invited Assistant Professor Dr. Sharif Shams Imon’s teaching career spans over 20 years. He holds a Ph.D. in Urban Conservation from the University of Hong Kong, has research interests in topics related to urban heritage tourism, heritage interpretation and urban conservation, and is a member of 6 professional bodies. Professionally, he has worked as a consultant for UNESCO, UNESCAP and government projects in 14 different countries, and is a technical evaluator for nominated UNESCO World Heritage sites and an ICOMOS expert member for World Heritage monitoring since 2005.',
    },
    image: '/images/tourism/team-02.jpg',
    textLength: 700,
  },
  {
    name: {
      zh: '林靜芝',
      en: 'CINDIA LAM',
    },
    title: {
      zh: '夜間學位課程主任<br/>澳門',
      en: 'Coordinator for Evening Degree Programmes, <br/>Macao',
    },
    description: {
      zh: '副教授林靜芝博士擁有葡萄牙天主教大學的工商管理博士及英國愛丁堡赫瑞瓦特大學工商管理系國際貿易及財務碩士。林博士主力研究醫療旅遊、旅遊保險、旅遊到顧客心理等相關領域。她主要任教服務質量管理和會計相關的課程，也曾為澳門特區政府的多個項目擔任顧問。',
      en: 'Assistant Professor Dr. Cindia Lam holds the degree of Ph.D. in Business Administration from the Catholic University of Portugal, with a focus in Accounting and Master in International Trade and Finance from Heriot-Watt University of United Kingdom. The research of Dr. Lam spans from niche areas of tourism, like medical tourism, tourism insurance and wine tourism, to consumer and employee psychology. She is a specialist in teaching service quality management and accounting courses. She has also served as a consultant to the Macao SAR Government on many of its projects.',
    },
    image: '/images/tourism/team-03.jpg',
  },
  {
    name: {
      zh: '呂劍英',
      en: 'CONNIE LOI',
    },
    title: {
      zh: '旅遊高等學校代副校長<br/>酒店管理和旅遊會展及節目管理課程主任<br/>澳門',
      en: 'Acting Vice Director of the Tourism College,<br/>Coordinator for Hotel Management,<br/>Tourism Event Management, Macao',
    },
    description: {
      zh: '副教授呂劍英博士是旅遊學院校友，2001年於學院獲得旅遊企業管理學士學位及酒店管理高級文憑。隨後，她成功取得澳洲詹姆士庫克大學哲學博士學位。呂劍英博士的研究領域包括酒店客人滿意度、目的地營銷、旅客行為和旅遊產品管理等，其著作經常出現在各大國際學術期刊及研討會論文集。',
      en: 'Assistant Professor Dr. Connie Loi’s career has brought her full-circle. Dr. Loi studied Tourism Business Management at IFT and graduated in 2001. She also earned a Higher Diploma in Hotel Management from the Institute. She subsequently received a Ph.D. in Tourism from James Cook University in Australia. Her current research interests include hotel guest satisfaction, destination marketing, tourist behaviour and tourism product management. Results of her research appear frequently in international academic journals and in conference proceedings in the field of tourism and hospitality.',
    },
    image: '/images/tourism/team-04.jpg',
    textLength: 330,
  },
  {
    name: {
      zh: '任蓮萍',
      en: 'EVE REN',
    },
    title: {
      zh: '旅遊零售及市場推廣管理課程主任<br/>中國內地',
      en: 'Coordinator for Tourism Retail and Marketing Management,<br/>Mainland China',
    },
    description: {
      zh: '副教授任蓮萍博士擁有香港理工大學酒店及旅遊管理博士學位，曾在中國內地及香港特別行政區的多間高等教育機構任教，也參與旅遊及酒店相關範疇的教科書編撰工作，曾多次在國際學術期刊發表研究成果。在早期的職業生涯，任蓮萍博士曾投身旅遊和酒店業。目前，她在學院負責統籌與企業管理相關的學科。',
      en: 'Assistant Professor Dr. Eve Ren holds a doctorate in Hotel and Tourism Management, which she earned at the Hong Kong Polytechnic University. Dr. Ren has taught in institutions of higher education in Mainland China and the Hong Kong SAR, contributed to textbooks on tourism and hospitality, and has been publishing research papers in international academic journals. Earlier in her career, Dr. Ren worked full-time in tourism and hospitality. At IFT, she oversees subjects in the field of business management.',
    },
    image: '/images/tourism/team-05.jpg',
    textLength: 360,
  },
]
